import { createApp } from 'vue'
import App from './App.vue'
import { setupMock } from '@/services/api-mock-service.js'
import { state } from './lib/state'
import mitt from 'mitt'
import { getMasterDataForMember } from './services/user-data-service'

const appElement = document.querySelector('#app')

const id = appElement.getAttribute('data-id')
const culture = appElement.getAttribute('data-culture')

// Get authentication status from the app element
const isAuthenticated = appElement.getAttribute('data-is-authenticated') === 'True'

const urlParams = new URLSearchParams(window.location.search)
const segParam = urlParams.get('seg')

// Add a small delay to ensure segmentation is initialized
setTimeout(() => {
  // First dispatch segmentation reset
  window.dispatchEvent(new CustomEvent("segmentation-reset"));

  // Small additional delay to ensure reset is processed
  setTimeout(() => {
    // Priority 1: URL parameter seg takes precedence if present
    if (segParam) {
      const eventType = "subscriptiontype-" + segParam;
      window.dispatchEvent(new CustomEvent(eventType));
    } 
    // Priority 2: If no URL parameter, use the authentication status
    else {
      const authEventType = isAuthenticated ? "subscriptiontype-member" : "subscriptiontype-non-member";
      window.dispatchEvent(new CustomEvent(authEventType));
    }
  }, 50); // Small delay between reset and event
}, 100); // Initial delay to ensure DOM is ready

const startupRequests = [
  { key: 'data', url: `/umbraco/delivery/api/v2/content/item/${id}` },
  { key: 'dictionary', url: `/umbraco/api/salaryApp/GetDictionary?culture=${culture}` },
  { key: 'lists', url: `/umbraco/api/salaryApp/GetLists?culture=${culture}` },
]

const startupState = {}
const emitter = mitt()

// Set loading state to show spinner before data is ready
state.isDataFetched = false

// Mount the app first

const app = createApp(App, {
  isAuth: isAuthenticated,
})
app.config.globalProperties.emitter = emitter
app.mount('#app')

// Fetch data asynchronously
async function fetchStartupData() {
  for (const request of startupRequests) {
    try {
      const response = await fetch(request.url)
      startupState[request.key] = await response.json()
    } catch (error) {
      // Silent error handling
    }
  }

  if(isAuthenticated){
      await getMasterDataForMember("da-DK")
  }


  // Populate state after data is loaded
  Object.assign(state, {
    memberBenefitsTitle: startupState.data?.properties?.memberBenefitsTitle || '',
    generalBenefitsTitle: startupState.data?.properties?.generalBenefitsTitle || '',
    benefitsTitle: startupState.data?.properties?.benefitsTitle || '',
    memberBenefits: startupState.data?.properties?.memberBenefits?.items || [],
    generalBenefits: startupState.data?.properties?.generalBenefits?.items || [],
    dictionary: startupState.dictionary || {},
    lists: startupState.lists || {},
    questions: startupState.data?.properties?.questions?.items || [],
    resultTypicalSalaryTitle: startupState.data?.properties?.resultTypicalSalaryTitle || '',
    resultBenefitsTitle: startupState.data?.properties?.resultBenefitsTitle || '',
    resultGeographyTitle: startupState.data?.properties?.resultGeographyTitle || '',
    resultLinks: startupState.data?.properties?.resultLinks || [],
    resultMemberBenefitsTitle: startupState.data?.properties?.resultMemberBenefitsTitle || '',
    resultMemberBenefitsSubtitle: startupState.data?.properties?.resultMemberBenefitsSubtitle || '',
    resultMemberBenefits: startupState.data?.properties?.resultMemberBenefits?.items || [],
    resultMemberBenefitsLink: startupState.data?.properties?.resultMemberBenefitsLink?.[0] || '',
    salarySliderLabelQ1: startupState.data?.properties?.salarySliderLabelQ1 || '',
    salarySliderLabelQ2: startupState.data?.properties?.salarySliderLabelQ2 || '',
    salarySliderLabelQ3: startupState.data?.properties?.salarySliderLabelQ3 || '',
    salarySliderLabelQ4: startupState.data?.properties?.salarySliderLabelQ4 || '',
    culture,
    dataConsent: startupState.data?.properties?.dataConsent || '',
    juraMailActive: startupState.data?.properties?.juraMailActive || false,
  })

  // Ensure the spinner is visible
  state.isDataFetched = true
}

fetchStartupData()
setupMock() // TODO: remove mock-setup when real API is ready
